var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.currentComponent,{tag:"component"}),(!_setup.oemTopComponent)?_c(_setup.CareerAiLauncher,{attrs:{"placement":"top"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }